import { postRequest } from '@/core';
import { tripTemplates } from '@/requests';

export default async function autoScheduleRequest(options) {
	let url = tripTemplates.autoSchedulePath();
	await postRequest(url, {}, options);
}